import React from 'react';
import {
  ModalContentFullOverlay,
  ModalContent, ModalCloseButton
} from './ModalContentFull.styled';

import { CloseCircle } from '../../icons/CloseCircle';

export function ModalContentFull ({ children, handleModalClose }) {

  return (
    <ModalContentFullOverlay>
      <ModalCloseButton onClick={handleModalClose}>
        <CloseCircle />
      </ModalCloseButton>
      <ModalContent>
        {children}
      </ModalContent>
    </ModalContentFullOverlay>
  );
}
